module.exports = __webpack_public_path__ + "static/media/logo-fipe.ce1ca8c3.png";